export const EMAIL_REGEX =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const TEXT_FIELD_REGEX = /^[a-zA-Z0-9à-üÀ-Üç\s]+$/;

export const PHONE_NUMBER_REGEX = /^\+?(?:[0-9] ?){6,19}[0-9]$/;

export const PHONE_NUMBER_REGEX_NO_CODE = /^(?:[0-9] ?){6,15}[0-9]$/;

export const COUNTRY_CALLING_CODE_REGEX = /^[1-9][0-9]{0,3}$/; // Validates country calling codes (1-4 digits) without the + symbol

export const POSITIVE_INTEGER_WITHOUT_ZERO_REGEX = /^(?!0)\d+$/; // Validates positive integers without zero
